window.PurItemsOrdered = {

    prepareFilterForm: function () {
        var options = {
            success: function (data) {
                PurItemsOrdered.processFilterForm(data);
            }, dataType: "json"
        };
        MyForm.prepare("puritemsorderedFilterForm", "purchases_purItemsOrdered&action=updateListing", options);
        PurItemsOrdered.initTips();
    },

    processFilterForm: function(data){
        Listing.refresh("puritemsorderedListing", data, data.puritemsordered_metadatas);
        PurItemsOrdered.initTips();
    },

    initTips : function(){
        $("[tip_type=nbdocs]").each(function(){
            var itemId	= $(this).attr('tip_item_id');
            var declId	= $(this).attr('tip_decl_id');
            $(this).qtip({
                style: {
                    classes: 'qtip-custom qtip-rich',
                    def: false
                },
                position: {
                    viewport: true,
                    my: 'right top',
                    at: 'left center'
                },
                content: {
                    ajax: {
                        type: 'GET',
                        url: './?_f=purchases_purItemsOrdered',
                        data: {
                            action: 'popDocs',
                            itemId: itemId,
                            declId: declId
                        },
                        once: true
                    }
                },
                show: {
                    event: 'mouseover'
                },
                hide: {
                    event: 'mouseout',
                    fixed: true,
                    delay: 100
                },
            });
        });
    }
}
